<template>
	<div class="steps-header">
		<div class="item-prog" :class="{deactivated: step.status === 'deactivated',active: step.status === 'active'}"
		     v-for="step in steps" :key="step.id">
			<div class="icon-status" :class="{active: step.status === 'active'}">
				<inline-svg v-if="step.status === 'active' || step.status === 'deactivated'" :src="require('@/assets/img/circle-arrow-right.svg')"/>
				<inline-svg v-if="step.status === 'completed'" :src="require('@/assets/img/circle-checked.svg')"/>
			</div>
			<div class="item-prog-text">
				<span>{{step.name}}</span>
				<div v-if="step.tag" class="prog-details-label" :class="[step.status]">{{step.tag}}</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "steps-header",
	props:{
		steps:{
			type:Array
		}
	},

}
</script>

<style lang="scss" scoped>
.steps-header {
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	margin: 10px 0 20px;
	background: $light-silver;
	padding: 14px 20px;
	border-radius: 3px;
	.prog-details-label {
		background: #D5E5FF;
		border-radius: 6px;
		padding: 1px 8px;
		font-size: 13px;
		line-height: 150%;
		letter-spacing: 0.02em;
		color: #4368E0;
		display: inline-block;
		margin-top: 3px;

		&.completed {

		}
		&.active {
			background: #e7e8ee;
			color: #9b9da4;
		}
	}
	.item-prog {
		display: flex;
		align-items: start;
		&.active {
			.item-prog-text {
				//font-weight: 600;
				color: $blue;
			}
		}
	}
	.icon-status {
		display: flex;
		margin-right: 10px;
	}
	.icon-status.active svg {
		transform: rotate(90deg);
	}
	.item-prog-text {
		font-size: 14px;
		font-weight: 500;
		display: flex;
		flex-direction: column;
		gap: 6px;
		align-items: start;
	}
}
</style>
